import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-jason-blog/src/templates/page.js";
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Button, Image } from '$components';
import SpeakingEvents from '../components/Speaking/Events';
export const pageQuery = graphql`
  {
    file(relativePath: { eq: "images/jason-lengstorf-speaking.jpg"}) {
      childImageSharp {
        resize(width: 1300) {
          src
        }
        fluid(maxWidth: 690, traceSVG: { color: "#e7e3e8" }) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`I’m available for speaking gigs; just `}<a parentName="p" {...{
        "href": "mailto:speaking@lengstorf.com?subject=Speaking+Inquiry"
      }}>{`contact me`}</a>{`. I’d be happy to speak about my experiences with remote working, business-building, or web design and development.`}</p>
    <Image caption="Jason Lengstorf at the 2017 GraphQL Summit in San Francisco." creditLink="https://orangephotography.com/" credit="Orange Photography" mdxType="Image">
  <Img fluid={props.data.file.childImageSharp.fluid} alt="Jason Lengstorf at the 2017 GraphQL Summit in San Francisco." mdxType="Img" />
    </Image>
    <p>{`Currently I’m focusing on giving presentations in the following areas:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Work-Life Balance and Efficiency:`}</strong>{` raising awareness about the health and career risks of overworking, teaching high-efficiency habits, encouraging downtime`}</li>
      <li parentName="ul"><strong parentName="li">{`Building Effective Teams:`}</strong>{` process design, designing healthy culture, onboarding, internal training`}</li>
      <li parentName="ul"><strong parentName="li">{`Modern Front-End Development:`}</strong>{` progressive web apps, high-performance patterns, React + GraphQL, architecture, testing, functional programming`}</li>
      <li parentName="ul"><strong parentName="li">{`GraphQL:`}</strong>{` managing GraphQL servers, using GraphQL in microservice architectures, combining GraphQL with REST`}</li>
    </ul>
    <p>{`For a full list of the ideas I’m kicking around right now, see `}<a parentName="p" {...{
        "href": "https://github.com/jlengstorf/presentations"
      }}>{`my presentation list`}</a>{`. If I’ve given the presentation before, the slides are up there, too.`}</p>
    <SpeakingEvents mdxType="SpeakingEvents" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      